<template>
  <div>
    <ylContactJoinUsMobile v-if="isMobileScreen" />
    <ylContactJoinUsPC v-else />
  </div>
</template>
<script>
export default {
  name: "ylContactJoinUs",
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  components: {
    ylContactJoinUsMobile: () => import("./components/mobile.vue"),
    ylContactJoinUsPC: () => import("./components/pc.vue"),
  },
};
</script>